// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HotelForm — Responsive Styles
 * MUI: compact below md (max 899px); desktop md and up (900px+).
 * iOS: font ≥16px for inputs; sheets use min 100dvh; safe-area padding.
 */

/* ===== Base resets ===== */
.hotel-search-strip,
.hotel-location-dropdown,
.hotel-date-picker-popup,
.hotel-guest-dropdown {
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
  box-sizing: border-box;
}

.hotel-search-strip {
  position: relative;
}

/* ===== iOS input zoom prevention ===== */
.hotel-search-strip input,
.hotel-form-compact-card input {
  font-size: max(16px, inherit);
  appearance: none;
}

/* ===== Location Dropdown ===== */
.hotel-location-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 350px;
  padding: 4px 0;
  scrollbar-width: thin;
  scrollbar-color: #000 transparent;
}

/* Desktop dropdown variant mirrors the Flight FROM/TO popper:
 * gray panel with rounded corners, in-list search bar pinned on top.
 */
.hotel-location-dropdown--desktop {
  top: calc(100% + 8px);
  left: -16px;
  right: auto;
  width: 392px;
  min-width: 392px;
  max-width: calc(100vw - 32px);
  max-height: none;
  padding: 16px;
  background-color: var(--yovo-grey-100, #F5F5F7);
  border: none;
  border-radius: 16px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.hotel-dropdown-search-bar {
  display: flex;
  align-items: center;
  background: #E8E9ED;
  border-radius: 12px;
  padding: 12px 10px;
  gap: 16px;
  flex-shrink: 0;
}

.hotel-dropdown-search-bar-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #20202A;
}

.hotel-dropdown-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #20202A;
  width: 100%;
  appearance: none;
  padding: 0;
}

.hotel-dropdown-search-input::placeholder {
  color: #AEAEB8;
  opacity: 1;
}

.hotel-dropdown-results {
  margin-top: 12px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hotel-dropdown-results::-webkit-scrollbar {
  display: none;
}

.hotel-location-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  line-height: 0;
}

.hotel-autocomplete-stars {
  color: #F5C518;
  font-weight: 700;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.hotel-autocomplete-label {
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hotel-autocomplete-load-more {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 10px 16px 12px;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #20202A;
}

.hotel-autocomplete-load-more span {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.hotel-autocomplete-load-more-icon {
  font-size: 18px !important;
  flex-shrink: 0;
}

.hotel-autocomplete-load-more:hover {
  background: #f5f5f5;
}

.hotel-dropdown-section-title {
  padding: 8px 16px 6px;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.hotel-dropdown-empty {
  padding: 24px 16px;
  text-align: center;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 14px;
  color: #7E808F;
}

.hotel-location-dropdown::-webkit-scrollbar {
  width: 6px;
}

.hotel-location-dropdown::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

.hotel-location-dropdown::-webkit-scrollbar-thumb {
  background: #000;
  border-radius: 3px;
}

.hotel-location-dropdown::-webkit-scrollbar-thumb:hover {
  background: #333;
}

.hotel-location-option {
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  min-height: 60px;
  transition: background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.hotel-location-option:hover {
  background-color: #f5f5f5;
}

.hotel-location-option:active {
  background-color: #ededf0;
}

.hotel-nearby-location-option {
  border-bottom: 1px solid #E8E9ED;
}

/* ===== Date Picker Popup (matches FlightForm) ===== */
.hotel-date-picker-popup {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background-color: #fff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  padding: 10px;
  padding-top: 12px;
  min-width: 600px;
  max-width: 650px;
  width: auto;
  margin-top: 4px;
  overflow-x: visible;
}

.hotel-date-picker-inner {
  display: flex;
  justify-content: center;
  width: 100%;
}

.hotel-date-picker-inner .react-datepicker {
  display: flex !important;
  flex-direction: row !important;
  gap: 12px !important;
  width: 100% !important;
  justify-content: center !important;
}

.hotel-date-picker-inner .react-datepicker__month-container {
  flex: 1 1;
  min-width: 0;
}

/* ===== Guest / Room Dropdown ===== */
.hotel-guest-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 20px;
  min-width: 320px;
  width: 340px;
  margin-top: 8px;
}

.hotel-guest-stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.hotel-guest-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 50% !important;
  -webkit-tap-highlight-color: transparent;
}

.hotel-guest-btn:hover {
  background-color: #f5f5f5 !important;
}

/* ===============================================
   DESKTOP (900px+) — matches Figma 2586:118700
   Filter strip: 24px rounded, 36px left / 12px right / 12px y padding,
   inner divider lines between fields.
   =============================================== */
@media (min-width: 900px) {
  .hotel-search-strip {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 0;
    row-gap: 0;
    justify-content: flex-start;
    padding: 12px 12px 12px 24px;
    border-radius: 24px;
    border: 1px solid var(--yovo-grey-300, #D6D9E0);
    background: var(--yovo-base-white, #FBFBFB);
    overflow: visible;
    align-items: center;
  }

  .hotel-search-field {
    position: relative;
    padding: 0 14px;
  }

  .hotel-search-field:first-of-type {
    padding-left: 0;
  }

  /* Desktop destination autocomplete — same footprint as flight dropdown icon row */
  .hotel-destination-dropdown-icon {
    width: 17px;
    height: 17px;
    margin-right: 10px;
    flex-shrink: 0;
    margin-top: 3px;
    display: block;
  }
}

/* Below the wide row: three fields on top, the rest with Let's Go underneath. */
@media (min-width: 900px) and (max-width: 1199.98px) {
  .hotel-search-strip {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 24px;
    row-gap: 12px;
  }
}

/* Wide desktop: one row, fields share the bar. Dates keep the min width from the layout helper. */
@media (min-width: 1200px) {
  .hotel-search-strip {
    flex-wrap: nowrap;
    padding: 12px 12px 12px 36px;
  }

  .hotel-search-field {
    padding: 0 20px;
  }
}

/* ===============================================
   MID-VIEWPORT (900px – 1023px)
   =============================================== */
@media (min-width: 900px) and (max-width: 1023px) {
  .hotel-date-picker-popup {
    min-width: 480px;
    max-width: 560px;
    padding: 10px;
  }

  .hotel-date-picker-inner .react-datepicker {
    gap: 8px !important;
  }

  .hotel-location-dropdown {
    min-width: 300px;
  }
}

/* ===============================================
   COMPACT / MOBILE-TABLET (max 899px)
   =============================================== */
@media (max-width: 899.98px) {
  .hotel-search-strip {
    flex-direction: column;
    gap: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    background: transparent;
  }

  .hotel-search-field {
    width: 100%;
    padding: 10px 4px;
    border-bottom: 1px solid #E8E9ED;
  }

  .hotel-search-field:last-of-type {
    border-bottom: none;
  }

  .hotel-location-dropdown {
    min-width: 0;
    max-height: min(55vh, 400px);
    border-radius: 12px;
    left: -4px;
    right: -4px;
  }

  .hotel-location-option {
    padding: 10px 14px;
    min-height: 52px;
  }

  .hotel-date-picker-popup.hotel-date-fullscreen {
    position: fixed;
    inset: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: none;
    z-index: 1310;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 100dvh;
    min-height: 100dvh;
    max-height: 100dvh;
    margin: 0;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fbfbfb;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
  }

  .hotel-date-picker-popup.hotel-date-fullscreen .hotel-date-picker-inner {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 12px 12px;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    touch-action: pan-y;
  }

  .hotel-date-sheet-header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: max(8px, env(safe-area-inset-top)) 16px 12px;
    border-bottom: 1px solid #e8e9ed;
    background: #fbfbfb;
    box-sizing: border-box;
  }

  .hotel-date-sheet-footer {
    flex-shrink: 0;
    padding: 12px 16px;
    padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
    border-top: 1px solid #e8e9ed;
    background: #fbfbfb;
    box-sizing: border-box;
  }

  /* Figma Search Date — check-in / check-out summary pills above Save */
  .hotel-date-footer-cards {
    display: flex;
    gap: clamp(8px, 2.5vw, 12px);
    width: 100%;
    margin-bottom: 12px;
  }

  .hotel-date-footer-card {
    flex: 1 1 50%;
    min-width: 0;
    position: relative;
    padding: 10px clamp(28px, 9vw, 36px) 10px 12px;
    border-radius: 12px;
    background: #f5f5f7;
    border: 2px solid transparent;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    font: inherit;
    cursor: pointer;
    text-align: left;
    color: inherit;
    margin: 0;
  }

  .hotel-date-footer-card--active {
    background: #fbfbfb;
    border-color: #20202a;
  }

  .hotel-date-footer-card-clear {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 4px;
    line-height: 0;
    color: #545665;
    background: transparent;
    border: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .hotel-date-picker-inner .react-datepicker {
    flex-direction: column !important;
    width: 100% !important;
    max-width: 100% !important;
    border: none !important;
    box-shadow: none !important;
  }

  .hotel-date-picker-inner .react-datepicker__month-container {
    width: 100% !important;
    float: none !important;
  }

  .hotel-date-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1309;
    background: rgba(32, 32, 42, 0.45);
    -webkit-tap-highlight-color: transparent;
  }

  .hotel-guest-dropdown {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1310;
    min-width: 100%;
    width: 100%;
    border-radius: clamp(1.25rem, 5vw, 2rem) clamp(1.25rem, 5vw, 2rem) 0 0;
    box-shadow: 0 -8px 32px rgba(32, 32, 42, 0.14);
    padding: 20px 16px;
    padding-bottom: max(20px, env(safe-area-inset-bottom, 0px));
  }

  .hotel-guest-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1309;
    background: rgba(32, 32, 42, 0.45);
    -webkit-tap-highlight-color: transparent;
  }

  .hotel-guest-btn {
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
  }

  .hotel-search-btn {
    width: 100%;
    margin-left: 0;
    margin-top: 4px;
  }
}

/* ===== Hotel date picker — full calendar theme ===== */

/* Base calendar container */
.hotel-date-picker-inner .custom-datepicker-single-month {
  border: none !important;
  box-shadow: none !important;
  font-family: 'Host Grotesk', sans-serif !important;
  width: 100% !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker {
  display: flex !important;
  justify-content: center !important;
  padding: 0 !important;
  width: 100% !important;
}

/* Header */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__header {
  background-color: transparent !important;
  border-bottom: none !important;
  padding: 0 !important;
  margin-bottom: 8px !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__current-month {
  color: #000 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  margin-bottom: 8px !important;
  text-align: center !important;
}

/* Day names row */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day-names {
  display: flex !important;
  justify-content: space-between !important;
  margin-bottom: 4px !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day-name {
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 32px !important;
  text-align: center !important;
  flex: 1 1 !important;
}

/* Month + week grid */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__month {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__week {
  display: flex !important;
  justify-content: space-between !important;
  margin: 0 !important;
  margin-bottom: 2px !important;
}

/* Day cells */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day {
  color: #333 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 32px !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: transparent !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day:hover {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

/* Month container */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__month-container {
  background-color: #fff !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  min-width: 200px !important;
}

/* State overrides — disabled, outside-month, today, keyboard-selected */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--disabled {
  color: #ccc !important;
  background-color: transparent !important;
  cursor: not-allowed !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--outside-month {
  visibility: hidden !important;
  pointer-events: none !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--outside-month {
  background-color: transparent !important;
  color: transparent !important;
  visibility: hidden !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--today {
  background-color: transparent !important;
  color: #333 !important;
  font-weight: 500 !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--keyboard-selected {
  background-color: transparent !important;
  color: #333 !important;
}

/* Remove blue highlighting */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--highlighted,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-1,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-2 {
  background-color: transparent !important;
  color: #333 !important;
}

/* Selection / range colours — theme red (yovoRed 400) */
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--in-selecting-range,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--range-start {
  background-color: #CF2048 !important;
  background: #CF2048 !important;
  color: #fff !important;
  border-radius: 25% !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-range,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--selected {
  background-color: #CF2048 !important;
  background: #CF2048 !important;
  color: #fff !important;
  border-radius: 25% !important;
  font-weight: 700 !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start[style],
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected[style] {
  background-color: #CF2048 !important;
  background: #CF2048 !important;
  color: #fff !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-end,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-end.react-datepicker__day--in-range {
  background-color: #CF2048 !important;
  color: #fff !important;
  border-radius: 25% !important;
  font-weight: 700 !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start:hover,
.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-end:hover {
  background-color: #CF2048 !important;
  color: #fff !important;
  border-radius: 25% !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--in-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
  background-color: rgba(255, 222, 229, 0.56) !important;
  color: #333 !important;
}

.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
  background-color: rgba(255, 222, 229, 0.56) !important;
  color: #333 !important;
}

/* ===== iOS safe area (landscape) ===== */
@supports (padding-left: env(safe-area-inset-left)) {
  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
    .hotel-date-picker-popup.hotel-date-fullscreen,
    .hotel-date-sheet-header,
    .hotel-date-sheet-footer {
      padding-left: max(16px, env(safe-area-inset-left));
      padding-right: max(16px, env(safe-area-inset-right));
    }
  }
}

/* ===== iOS Safari flexbox fixes ===== */
@supports (-webkit-touch-callout: none) {
  .hotel-search-strip {
    -webkit-overflow-scrolling: touch;
  }

  .hotel-location-dropdown {
    overscroll-behavior: contain;
  }
}

/* Dropdown-style tap targets — compact homepage hotel (Flight-inspired). */
.hotel-mobile-dropdown-trigger {
  min-height: clamp(2.75rem, 11vw, 3rem);
  border-radius: 8px;
  box-sizing: border-box;
}

.hotel-mobile-guest-sheet-scroll {
  padding-bottom: 8px;
}

/* Figma 3013:158684 — hotel homepage mobile “Travellers and Class” sheet */
.mobile-travellers-sheet.hotel-mobile-guests-sheet.open {
  background: #f5f5f7 !important;
}

.hotel-mobile-guests-sheet .mobile-travellers-sheet-header {
  background: #fbfbfb;
}

.hotel-mobile-guests-sheet .hotel-mobile-guest-select-label {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.hotel-mobile-guests-sheet .hotel-mobile-guest-picker-section {
  margin-bottom: 32px;
}

.hotel-mobile-guests-sheet .hotel-mobile-room-block {
  margin-bottom: 8px;
}

.hotel-mobile-guests-sheet .hotel-mobile-room-heading {
  margin: 0 0 12px;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #20202a;
}

.hotel-mobile-guests-sheet .mobile-travellers-section-title {
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #545665 !important;
}

.hotel-mobile-guests-sheet .mobile-travellers-section-hint {
  font-size: 14px !important;
  line-height: 20px !important;
  font-weight: 400 !important;
  color: #aeaeb8 !important;
}

.hotel-mobile-guests-sheet .hotel-mobile-guest-equal-row.mobile-travellers-num-row {
  gap: 10px;
}

.hotel-mobile-guests-sheet .hotel-mobile-guest-equal-row .mobile-travellers-num-chip {
  flex: 1 1;
  min-width: 0;
  min-height: unset;
  height: auto;
  padding-top: 6px;
  padding-bottom: 6px;
  border-radius: 8px;
  font-weight: 400 !important;
}

.hotel-mobile-guests-sheet .hotel-mobile-guest-equal-row .mobile-travellers-num-chip--active {
  background: #cf2048 !important;
  border-color: #cf2048 !important;
  color: #fbfbfb !important;
}

.hotel-mobile-guests-sheet .mobile-travellers-sheet-footer.hotel-mobile-guests-footer {
  background: #fbfbfb;
}

.hotel-mobile-guests-sheet .hotel-mobile-guests-footer-line1.mobile-travellers-sheet-footer-line1 {
  color: #545665 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0.4px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.hotel-mobile-guests-sheet .hotel-mobile-guest-footer-dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #7e808f;
  flex-shrink: 0;
}

.hotel-mobile-guests-sheet .hotel-mobile-guests-footer-dates.mobile-travellers-sheet-footer-line2 {
  color: #7e808f !important;
}

/* Mobile guest sheet — child age opens custom bottom sheet (no native <select>) */
.hotel-mobile-guests-sheet .hotel-mobile-child-ages-block {
  padding-bottom: 4px;
}

.hotel-mobile-guests-sheet button.hotel-mobile-child-age-trigger {
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  font: inherit;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

/* Child age picker — stacks above travellers sheet (z-index in JS) */
[data-hotel-mobile-child-age-picker] .hotel-mobile-child-age-sheet-chip.mobile-travellers-num-chip {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(16.666% - 9px);
  min-width: 2.75rem;
  max-width: 4rem;
  min-height: 2.75rem;
  padding: 8px 4px;
  font-weight: 500;
}

[data-hotel-mobile-child-age-picker] .mobile-travellers-num-chip--active {
  background: #cf2048 !important;
  border-color: #cf2048 !important;
  color: #fbfbfb !important;
}

/* ── Hotel mobile destination sheet (Hotels-only shell; mirrors Flight airport sheet layout) ── */
.hotel-mobile-destination-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1328;
  background: rgba(32, 32, 42, 0.45);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.22s ease, visibility 0.22s ease;
  -webkit-tap-highlight-color: transparent;
}

.hotel-mobile-destination-backdrop.open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.hotel-mobile-destination-sheet {
  position: fixed;
  z-index: 1329;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #fff;
  transform: translate3d(0, 100%, 0);
  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0, 1);
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

@media (max-width: 899.98px) {
  .hotel-mobile-destination-sheet {
    inset: 0;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
    box-shadow: none;
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
}

.hotel-mobile-destination-sheet.open {
  transform: translate3d(0, 0, 0);
}

.hotel-mobile-destination-sheet > *:not(.mobile-sheet-results) {
  flex-shrink: 0;
}

/* Inline trigger — same gray tile as Flight mobile-sheet-field */
.hotel-mobile-sheet-field {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  border-radius: 12px;
  border: 2px solid transparent;
  background: #f5f5f7;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  font: inherit;
  color: inherit;
  text-align: left;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
}

.hotel-mobile-sheet-field:focus-visible {
  outline: none;
  border-color: #cf2048;
  background: #fff;
}

.hotel-mobile-sheet-field:active {
  background: #ededf0;
}

.hotel-mobile-sheet-field-icon {
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: #20202a;
}

.hotel-mobile-sheet-field-label {
  font-family: 'Host Grotesk', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
  color: #7e808f;
  margin-bottom: 0.125rem;
  display: block;
}

.hotel-mobile-sheet-field-value {
  font-family: 'Host Grotesk', sans-serif;
  font-size: max(16px, 1rem);
  font-weight: 600;
  line-height: 1.5;
  color: #20202a;
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hotel-mobile-sheet-field-value--muted {
  color: #aeaeb8;
  font-weight: 500;
}

/* ===== Phase 1 — Figma 3013:152666 compact container (mobile + tablet <900px) ===== */
@media (max-width: 899.98px) {
  .hotel-form-compact-card {
    background: #e8e9ed;
    border: none;
    box-shadow: none;
    border-radius: var(--yovo-radius-lg, 16px);
  }

  .hotel-form-compact-card > .MuiCardContent-root {
    display: flex;
    flex-direction: column;
    gap: var(--yovo-space-base, 16px);
    padding: 16px 12px 24px;
    box-sizing: border-box;
  }

  .hotel-form-compact-card > .MuiCardContent-root:last-child {
    padding-bottom: 24px;
  }

  .hotel-form-compact-stack {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    width: 100%;
  }

  .hotel-form-compact-inner {
    background: var(--yovo-base-white, #FBFBFB);
    border: 1px solid var(--neutrals-grey-400, #DAD9E0);
    border-radius: 24px;
    padding: 12px 16px 8px;
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .hotel-form-compact-divider {
    display: none;
  }

  /* Same row rhythm as the mobile flight card: 14/20 labels, 16/22 values, 10/8 row padding. */
  .hotel-form-compact-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 4px 8px;
    border-bottom: 1px solid #e8e9ed;
  }

  .hotel-form-compact-inner > .hotel-form-compact-field:first-child {
    padding-top: 8px;
    padding-bottom: 10px;
  }

  .hotel-form-compact-inner > .hotel-form-compact-field:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  .hotel-form-compact-field--align-end {
    align-items: flex-end;
  }

  .hotel-form-compact-field--align-end .hotel-form-compact-label,
  .hotel-form-compact-field--align-end .hotel-form-compact-value,
  .hotel-form-compact-field--align-end .hotel-form-compact-value-trigger {
    text-align: right;
  }

  .hotel-form-compact-label,
  .hotel-form-compact-label--destination {
    font-family: 'Host Grotesk', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #20202a;
  }

  .hotel-form-compact-value {
    font-family: 'Host Grotesk', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: #20202a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .hotel-form-compact-value--placeholder {
    color: #7e808f;
    font-weight: 500;
  }

  .hotel-form-compact-value-trigger {
    width: 100%;
    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .hotel-form-compact-error {
    font-family: var(--yovo-font-primary);
    font-size: var(--yovo-text-sm);
    line-height: var(--yovo-leading-sm);
    color: var(--yovo-error, #D32F2F);
    margin-top: 2px;
  }

  .hotel-form-compact-helper {
    font-family: var(--yovo-font-primary);
    font-size: 11px;
    line-height: 1.3;
    color: var(--yovo-warning, #E65100);
    margin-top: var(--yovo-space-xs, 4px);
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield {
    width: 100%;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiOutlinedInput-root {
    border-radius: 0;
    min-height: auto;
    height: auto;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiOutlinedInput-root fieldset {
    border: none;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiOutlinedInput-root.Mui-focused fieldset {
    border: none;
    box-shadow: none;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiInputBase-input {
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Host Grotesk', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: #20202a;
    width: 100%;
    white-space: nowrap;
    padding: 0 !important;
    margin: 0;
    cursor: pointer;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiInputBase-input::placeholder {
    color: #7e808f;
    font-weight: 500;
    opacity: 1;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield--nationality .MuiOutlinedInput-root {
    padding-right: 28px;
  }

  .hotel-form-compact-inner .hotel-form-compact-textfield--nationality .MuiInputBase-input {
    caret-color: transparent !important;
  }

  /* Hotel date row — Figma 3013:152666; stretch columns so swap aligns with label+value block */
  .hotel-form-compact-date-row {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 4px 8px;
    border-bottom: 1px solid #e8e9ed;
  }

  .hotel-form-compact-date-row > .hotel-form-compact-field {
    flex: 1 1;
    min-width: 0;
    padding: 0;
    border-bottom: none;
  }

  /*
   * Hotel swap column — Flight .flight-form-swap-col assumes .flight-search-strip-from-to-row
   * (stretched airport fields). The hotel date row is label+value stacks, so the column is
   * centred on the row instead and the rule is sized independently below.
   */
  .hotel-form-compact-swap-col {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    width: 40px;
    min-width: 40px;
    align-self: center;
    padding: 0;
    box-sizing: border-box;
  }

  /*
   * Divider — Figma 3013:160331 is a 68px rule centred on the swap column. The 34px circle
   * sits in the middle, leaving 17px visible above and below. The track is sized to the
   * Figma rule rather than the date row, which is only ~46px tall.
   */
  .hotel-form-compact-swap-divider-track {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1px;
    height: 44px;
    transform: translate(-50%, -50%);
    z-index: 0;
    pointer-events: none;
  }

  .hotel-form-compact-swap-divider-segment {
    position: absolute;
    left: 0;
    width: 1px;
    height: 6px;
    background-color: var(--neutrals-grey-400, #DAD9E0);
  }

  .hotel-form-compact-swap-divider-segment--top {
    top: 0;
  }

  .hotel-form-compact-swap-divider-segment--bottom {
    bottom: 0;
  }

  /*
   * Portalled to <body>, so it clears the homepage card's stacking context and the
   * absolutely-positioned section content below it (e.g. "Explore What's Trending").
   * Same z-index band as the hotel mobile sheets.
   */
  .hotel-form-compact-nationality-menu {
    z-index: 1310;
    background-color: var(--yovo-base-white, #FBFBFB);
  }

  .hotel-form-compact-swap-col .flight-form-swap {
    border-color: var(--neutrals-grey-800, #434151);
  }

  /*
   * Figma 3013:160333 draws the swap at full strength, so the empty-dates state keeps the
   * same border and arrow contrast; \`disabled\` still blocks the (no-op) click.
   */
  .hotel-form-compact-inner .flight-form-swap:disabled {
    opacity: 1;
  }

  .hotel-form-compact-inner .flight-form-swap:disabled:hover,
  .hotel-form-compact-inner .flight-form-swap:disabled:active {
    background: var(--neutrals-base-white, #FBFBFB);
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Homepage/styles/HotelForm.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,4BAA4B;AAC5B;;;;EAIE,wCAAwC;EAExC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;;EAEE,6BAA6B;EAE7B,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;;EAEE;AACF;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,WAAW;EAEX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;oDAIoD;AACpD;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,+CAA+C;IAC/C,2CAA2C;IAC3C,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,kFAAkF;EAClF;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA,kGAAkG;AAClG;EACE;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;oDAEoD;AACpD;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;oDAEoD;AACpD;EACE;IACE,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,eAAe;IACf,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qDAAqD;IACrD,gCAAgC;IAChC,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,2DAA2D;IAC3D,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,sEAAsE;EACtE;IACE,aAAa;IACb,4BAA4B;IAC5B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,iCAAiC;IACjC,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,kCAAkC;IAClC,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,eAAe;IACf,WAAW;IACX,sEAAsE;IACtE,8CAA8C;IAC9C,kBAAkB;IAClB,2DAA2D;EAC7D;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,kCAAkC;IAClC,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,wDAAwD;;AAExD,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,wEAAwE;AACxE;EACE,sBAAsB;EACtB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;;;EAGE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;;;EAIE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE;IACE;;;MAGE,kDAAkD;MAClD,oDAAoD;IACtD;EACF;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,2EAA2E;AAC3E;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kFAAkF;AAClF;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,qEAAqE;AACrE;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,kGAAkG;AAClG;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,0DAA0D;EAC1D,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;IACE,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,gDAAgD;EAClD;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gEAAgE;EAChE,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,2CAA2C;IAC3C,mDAAmD;IACnD,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA,6FAA6F;EAC7F;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;IAC9B,mCAAmC;IACnC,iCAAiC;IACjC,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,qCAAqC;EACvC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;EAEA,8FAA8F;EAC9F;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;IACN,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;EACrB;;EAEA;;;;IAIE;EACF;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,sBAAsB;EACxB;;EAEA;;;;IAIE;EACF;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,WAAW;IACX,mDAAmD;EACrD;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,SAAS;EACX;;EAEA;;;;IAIE;EACF;IACE,aAAa;IACb,iDAAiD;EACnD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;;;IAGE;EACF;IACE,UAAU;EACZ;;EAEA;;IAEE,+CAA+C;EACjD;AACF","sourcesContent":["/* HotelForm — Responsive Styles\n * MUI: compact below md (max 899px); desktop md and up (900px+).\n * iOS: font ≥16px for inputs; sheets use min 100dvh; safe-area padding.\n */\n\n/* ===== Base resets ===== */\n.hotel-search-strip,\n.hotel-location-dropdown,\n.hotel-date-picker-popup,\n.hotel-guest-dropdown {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  box-sizing: border-box;\n}\n\n.hotel-search-strip {\n  position: relative;\n}\n\n/* ===== iOS input zoom prevention ===== */\n.hotel-search-strip input,\n.hotel-form-compact-card input {\n  font-size: max(16px, inherit);\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n/* ===== Location Dropdown ===== */\n.hotel-location-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-width: 350px;\n  padding: 4px 0;\n  scrollbar-width: thin;\n  scrollbar-color: #000 transparent;\n}\n\n/* Desktop dropdown variant mirrors the Flight FROM/TO popper:\n * gray panel with rounded corners, in-list search bar pinned on top.\n */\n.hotel-location-dropdown--desktop {\n  top: calc(100% + 8px);\n  left: -16px;\n  right: auto;\n  width: 392px;\n  min-width: 392px;\n  max-width: calc(100vw - 32px);\n  max-height: none;\n  padding: 16px;\n  background-color: var(--yovo-grey-100, #F5F5F7);\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.hotel-dropdown-search-bar {\n  display: flex;\n  align-items: center;\n  background: #E8E9ED;\n  border-radius: 12px;\n  padding: 12px 10px;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.hotel-dropdown-search-bar-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: #20202A;\n}\n\n.hotel-dropdown-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #20202A;\n  width: 100%;\n  -webkit-appearance: none;\n  appearance: none;\n  padding: 0;\n}\n\n.hotel-dropdown-search-input::placeholder {\n  color: #AEAEB8;\n  opacity: 1;\n}\n\n.hotel-dropdown-results {\n  margin-top: 12px;\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.hotel-dropdown-results::-webkit-scrollbar {\n  display: none;\n}\n\n.hotel-location-type-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  line-height: 0;\n}\n\n.hotel-autocomplete-stars {\n  color: #F5C518;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n\n.hotel-autocomplete-label {\n  display: block;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hotel-autocomplete-load-more {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  margin: 0;\n  padding: 10px 16px 12px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #20202A;\n}\n\n.hotel-autocomplete-load-more span {\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.hotel-autocomplete-load-more-icon {\n  font-size: 18px !important;\n  flex-shrink: 0;\n}\n\n.hotel-autocomplete-load-more:hover {\n  background: #f5f5f5;\n}\n\n.hotel-dropdown-section-title {\n  padding: 8px 16px 6px;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n}\n\n.hotel-dropdown-empty {\n  padding: 24px 16px;\n  text-align: center;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 14px;\n  color: #7E808F;\n}\n\n.hotel-location-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.hotel-location-dropdown::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 3px;\n}\n\n.hotel-location-dropdown::-webkit-scrollbar-thumb {\n  background: #000;\n  border-radius: 3px;\n}\n\n.hotel-location-dropdown::-webkit-scrollbar-thumb:hover {\n  background: #333;\n}\n\n.hotel-location-option {\n  padding: 12px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: flex-start;\n  min-height: 60px;\n  transition: background-color 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.hotel-location-option:hover {\n  background-color: #f5f5f5;\n}\n\n.hotel-location-option:active {\n  background-color: #ededf0;\n}\n\n.hotel-nearby-location-option {\n  border-bottom: 1px solid #E8E9ED;\n}\n\n/* ===== Date Picker Popup (matches FlightForm) ===== */\n.hotel-date-picker-popup {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  background-color: #fff;\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  padding: 10px;\n  padding-top: 12px;\n  min-width: 600px;\n  max-width: 650px;\n  width: auto;\n  margin-top: 4px;\n  overflow-x: visible;\n}\n\n.hotel-date-picker-inner {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.hotel-date-picker-inner .react-datepicker {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 12px !important;\n  width: 100% !important;\n  justify-content: center !important;\n}\n\n.hotel-date-picker-inner .react-datepicker__month-container {\n  flex: 1;\n  min-width: 0;\n}\n\n/* ===== Guest / Room Dropdown ===== */\n.hotel-guest-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 1000;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  padding: 20px;\n  min-width: 320px;\n  width: 340px;\n  margin-top: 8px;\n}\n\n.hotel-guest-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.hotel-guest-btn {\n  width: 36px !important;\n  height: 36px !important;\n  min-width: 36px !important;\n  border: 1px solid #e0e0e0 !important;\n  border-radius: 50% !important;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.hotel-guest-btn:hover {\n  background-color: #f5f5f5 !important;\n}\n\n/* ===============================================\n   DESKTOP (900px+) — matches Figma 2586:118700\n   Filter strip: 24px rounded, 36px left / 12px right / 12px y padding,\n   inner divider lines between fields.\n   =============================================== */\n@media (min-width: 900px) {\n  .hotel-search-strip {\n    flex-direction: row;\n    flex-wrap: wrap;\n    column-gap: 0;\n    row-gap: 0;\n    justify-content: flex-start;\n    padding: 12px 12px 12px 24px;\n    border-radius: 24px;\n    border: 1px solid var(--yovo-grey-300, #D6D9E0);\n    background: var(--yovo-base-white, #FBFBFB);\n    overflow: visible;\n    align-items: center;\n  }\n\n  .hotel-search-field {\n    position: relative;\n    padding: 0 14px;\n  }\n\n  .hotel-search-field:first-of-type {\n    padding-left: 0;\n  }\n\n  /* Desktop destination autocomplete — same footprint as flight dropdown icon row */\n  .hotel-destination-dropdown-icon {\n    width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    flex-shrink: 0;\n    margin-top: 3px;\n    display: block;\n  }\n}\n\n/* Below the wide row: three fields on top, the rest with Let's Go underneath. */\n@media (min-width: 900px) and (max-width: 1199.98px) {\n  .hotel-search-strip {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 12px 24px;\n    row-gap: 12px;\n  }\n}\n\n/* Wide desktop: one row, fields share the bar. Dates keep the min width from the layout helper. */\n@media (min-width: 1200px) {\n  .hotel-search-strip {\n    flex-wrap: nowrap;\n    padding: 12px 12px 12px 36px;\n  }\n\n  .hotel-search-field {\n    padding: 0 20px;\n  }\n}\n\n/* ===============================================\n   MID-VIEWPORT (900px – 1023px)\n   =============================================== */\n@media (min-width: 900px) and (max-width: 1023px) {\n  .hotel-date-picker-popup {\n    min-width: 480px;\n    max-width: 560px;\n    padding: 10px;\n  }\n\n  .hotel-date-picker-inner .react-datepicker {\n    gap: 8px !important;\n  }\n\n  .hotel-location-dropdown {\n    min-width: 300px;\n  }\n}\n\n/* ===============================================\n   COMPACT / MOBILE-TABLET (max 899px)\n   =============================================== */\n@media (max-width: 899.98px) {\n  .hotel-search-strip {\n    flex-direction: column;\n    gap: 0;\n    padding: 0;\n    border: none;\n    border-radius: 0;\n    background: transparent;\n  }\n\n  .hotel-search-field {\n    width: 100%;\n    padding: 10px 4px;\n    border-bottom: 1px solid #E8E9ED;\n  }\n\n  .hotel-search-field:last-of-type {\n    border-bottom: none;\n  }\n\n  .hotel-location-dropdown {\n    min-width: 0;\n    max-height: min(55vh, 400px);\n    border-radius: 12px;\n    left: -4px;\n    right: -4px;\n  }\n\n  .hotel-location-option {\n    padding: 10px 14px;\n    min-height: 52px;\n  }\n\n  .hotel-date-picker-popup.hotel-date-fullscreen {\n    position: fixed;\n    inset: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: none;\n    z-index: 1310;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    height: 100dvh;\n    min-height: 100dvh;\n    max-height: 100dvh;\n    margin: 0;\n    padding: 0;\n    border-radius: 0;\n    box-shadow: none;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    background-color: #fbfbfb;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-y: contain;\n  }\n\n  .hotel-date-picker-popup.hotel-date-fullscreen .hotel-date-picker-inner {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 0 12px 12px;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-y: contain;\n    touch-action: pan-y;\n  }\n\n  .hotel-date-sheet-header {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: max(8px, env(safe-area-inset-top)) 16px 12px;\n    border-bottom: 1px solid #e8e9ed;\n    background: #fbfbfb;\n    box-sizing: border-box;\n  }\n\n  .hotel-date-sheet-footer {\n    flex-shrink: 0;\n    padding: 12px 16px;\n    padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));\n    border-top: 1px solid #e8e9ed;\n    background: #fbfbfb;\n    box-sizing: border-box;\n  }\n\n  /* Figma Search Date — check-in / check-out summary pills above Save */\n  .hotel-date-footer-cards {\n    display: flex;\n    gap: clamp(8px, 2.5vw, 12px);\n    width: 100%;\n    margin-bottom: 12px;\n  }\n\n  .hotel-date-footer-card {\n    flex: 1 1 50%;\n    min-width: 0;\n    position: relative;\n    padding: 10px clamp(28px, 9vw, 36px) 10px 12px;\n    border-radius: 12px;\n    background: #f5f5f7;\n    border: 2px solid transparent;\n    box-sizing: border-box;\n    appearance: none;\n    -webkit-appearance: none;\n    font: inherit;\n    cursor: pointer;\n    text-align: left;\n    color: inherit;\n    margin: 0;\n  }\n\n  .hotel-date-footer-card--active {\n    background: #fbfbfb;\n    border-color: #20202a;\n  }\n\n  .hotel-date-footer-card-clear {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    padding: 4px;\n    line-height: 0;\n    color: #545665;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .hotel-date-picker-inner .react-datepicker {\n    flex-direction: column !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  .hotel-date-picker-inner .react-datepicker__month-container {\n    width: 100% !important;\n    float: none !important;\n  }\n\n  .hotel-date-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1309;\n    background: rgba(32, 32, 42, 0.45);\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .hotel-guest-dropdown {\n    position: fixed;\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1310;\n    min-width: 100%;\n    width: 100%;\n    border-radius: clamp(1.25rem, 5vw, 2rem) clamp(1.25rem, 5vw, 2rem) 0 0;\n    box-shadow: 0 -8px 32px rgba(32, 32, 42, 0.14);\n    padding: 20px 16px;\n    padding-bottom: max(20px, env(safe-area-inset-bottom, 0px));\n  }\n\n  .hotel-guest-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1309;\n    background: rgba(32, 32, 42, 0.45);\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .hotel-guest-btn {\n    width: 44px !important;\n    height: 44px !important;\n    min-width: 44px !important;\n  }\n\n  .hotel-search-btn {\n    width: 100%;\n    margin-left: 0;\n    margin-top: 4px;\n  }\n}\n\n/* ===== Hotel date picker — full calendar theme ===== */\n\n/* Base calendar container */\n.hotel-date-picker-inner .custom-datepicker-single-month {\n  border: none !important;\n  box-shadow: none !important;\n  font-family: 'Host Grotesk', sans-serif !important;\n  width: 100% !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker {\n  display: flex !important;\n  justify-content: center !important;\n  padding: 0 !important;\n  width: 100% !important;\n}\n\n/* Header */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__header {\n  background-color: transparent !important;\n  border-bottom: none !important;\n  padding: 0 !important;\n  margin-bottom: 8px !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__current-month {\n  color: #000 !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  margin-bottom: 8px !important;\n  text-align: center !important;\n}\n\n/* Day names row */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day-names {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-bottom: 4px !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day-name {\n  color: #333 !important;\n  font-weight: 600 !important;\n  font-size: 11px !important;\n  text-transform: uppercase !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 32px !important;\n  text-align: center !important;\n  flex: 1 !important;\n}\n\n/* Month + week grid */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__month {\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 100% !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__week {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin: 0 !important;\n  margin-bottom: 2px !important;\n}\n\n/* Day cells */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day {\n  color: #333 !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 32px !important;\n  height: 32px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background-color: transparent !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day:hover {\n  background-color: #f5f5f5 !important;\n  color: #333 !important;\n}\n\n/* Month container */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__month-container {\n  background-color: #fff !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 100% !important;\n  min-width: 200px !important;\n}\n\n/* State overrides — disabled, outside-month, today, keyboard-selected */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--disabled {\n  color: #ccc !important;\n  background-color: transparent !important;\n  cursor: not-allowed !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--outside-month {\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--outside-month {\n  background-color: transparent !important;\n  color: transparent !important;\n  visibility: hidden !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--today {\n  background-color: transparent !important;\n  color: #333 !important;\n  font-weight: 500 !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--keyboard-selected {\n  background-color: transparent !important;\n  color: #333 !important;\n}\n\n/* Remove blue highlighting */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--highlighted,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-1,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-2 {\n  background-color: transparent !important;\n  color: #333 !important;\n}\n\n/* Selection / range colours — theme red (yovoRed 400) */\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--in-selecting-range,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--range-start {\n  background-color: #CF2048 !important;\n  background: #CF2048 !important;\n  color: #fff !important;\n  border-radius: 25% !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-range,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--selected {\n  background-color: #CF2048 !important;\n  background: #CF2048 !important;\n  color: #fff !important;\n  border-radius: 25% !important;\n  font-weight: 700 !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start[style],\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--selected[style] {\n  background-color: #CF2048 !important;\n  background: #CF2048 !important;\n  color: #fff !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-end,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-end.react-datepicker__day--in-range {\n  background-color: #CF2048 !important;\n  color: #fff !important;\n  border-radius: 25% !important;\n  font-weight: 700 !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-start:hover,\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--range-end:hover {\n  background-color: #CF2048 !important;\n  color: #fff !important;\n  border-radius: 25% !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--in-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {\n  background-color: rgba(255, 222, 229, 0.56) !important;\n  color: #333 !important;\n}\n\n.hotel-date-picker-inner .custom-datepicker-single-month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {\n  background-color: rgba(255, 222, 229, 0.56) !important;\n  color: #333 !important;\n}\n\n/* ===== iOS safe area (landscape) ===== */\n@supports (padding-left: env(safe-area-inset-left)) {\n  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {\n    .hotel-date-picker-popup.hotel-date-fullscreen,\n    .hotel-date-sheet-header,\n    .hotel-date-sheet-footer {\n      padding-left: max(16px, env(safe-area-inset-left));\n      padding-right: max(16px, env(safe-area-inset-right));\n    }\n  }\n}\n\n/* ===== iOS Safari flexbox fixes ===== */\n@supports (-webkit-touch-callout: none) {\n  .hotel-search-strip {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .hotel-location-dropdown {\n    overscroll-behavior: contain;\n  }\n}\n\n/* Dropdown-style tap targets — compact homepage hotel (Flight-inspired). */\n.hotel-mobile-dropdown-trigger {\n  min-height: clamp(2.75rem, 11vw, 3rem);\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n.hotel-mobile-guest-sheet-scroll {\n  padding-bottom: 8px;\n}\n\n/* Figma 3013:158684 — hotel homepage mobile “Travellers and Class” sheet */\n.mobile-travellers-sheet.hotel-mobile-guests-sheet.open {\n  background: #f5f5f7 !important;\n}\n\n.hotel-mobile-guests-sheet .mobile-travellers-sheet-header {\n  background: #fbfbfb;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guest-select-label {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guest-picker-section {\n  margin-bottom: 32px;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-room-block {\n  margin-bottom: 8px;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-room-heading {\n  margin: 0 0 12px;\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #20202a;\n}\n\n.hotel-mobile-guests-sheet .mobile-travellers-section-title {\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  color: #545665 !important;\n}\n\n.hotel-mobile-guests-sheet .mobile-travellers-section-hint {\n  font-size: 14px !important;\n  line-height: 20px !important;\n  font-weight: 400 !important;\n  color: #aeaeb8 !important;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guest-equal-row.mobile-travellers-num-row {\n  gap: 10px;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guest-equal-row .mobile-travellers-num-chip {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: unset;\n  height: auto;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  border-radius: 8px;\n  font-weight: 400 !important;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guest-equal-row .mobile-travellers-num-chip--active {\n  background: #cf2048 !important;\n  border-color: #cf2048 !important;\n  color: #fbfbfb !important;\n}\n\n.hotel-mobile-guests-sheet .mobile-travellers-sheet-footer.hotel-mobile-guests-footer {\n  background: #fbfbfb;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guests-footer-line1.mobile-travellers-sheet-footer-line1 {\n  color: #545665 !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.4px !important;\n  line-height: 20px !important;\n  display: flex !important;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guest-footer-dot {\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: #7e808f;\n  flex-shrink: 0;\n}\n\n.hotel-mobile-guests-sheet .hotel-mobile-guests-footer-dates.mobile-travellers-sheet-footer-line2 {\n  color: #7e808f !important;\n}\n\n/* Mobile guest sheet — child age opens custom bottom sheet (no native <select>) */\n.hotel-mobile-guests-sheet .hotel-mobile-child-ages-block {\n  padding-bottom: 4px;\n}\n\n.hotel-mobile-guests-sheet button.hotel-mobile-child-age-trigger {\n  margin: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  font: inherit;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Child age picker — stacks above travellers sheet (z-index in JS) */\n[data-hotel-mobile-child-age-picker] .hotel-mobile-child-age-sheet-chip.mobile-travellers-num-chip {\n  flex: 1 1 calc(16.666% - 9px);\n  min-width: 2.75rem;\n  max-width: 4rem;\n  min-height: 2.75rem;\n  padding: 8px 4px;\n  font-weight: 500;\n}\n\n[data-hotel-mobile-child-age-picker] .mobile-travellers-num-chip--active {\n  background: #cf2048 !important;\n  border-color: #cf2048 !important;\n  color: #fbfbfb !important;\n}\n\n/* ── Hotel mobile destination sheet (Hotels-only shell; mirrors Flight airport sheet layout) ── */\n.hotel-mobile-destination-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1328;\n  background: rgba(32, 32, 42, 0.45);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.22s ease, visibility 0.22s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.hotel-mobile-destination-backdrop.open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.hotel-mobile-destination-sheet {\n  position: fixed;\n  z-index: 1329;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  background: #fff;\n  transform: translate3d(0, 100%, 0);\n  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0, 1);\n  overflow: hidden;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@media (max-width: 899.98px) {\n  .hotel-mobile-destination-sheet {\n    inset: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    height: 100dvh;\n    min-height: 100vh;\n    min-height: 100dvh;\n    max-height: 100vh;\n    max-height: 100dvh;\n    border-radius: 0;\n    box-shadow: none;\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n}\n\n.hotel-mobile-destination-sheet.open {\n  transform: translate3d(0, 0, 0);\n}\n\n.hotel-mobile-destination-sheet > *:not(.mobile-sheet-results) {\n  flex-shrink: 0;\n}\n\n/* Inline trigger — same gray tile as Flight mobile-sheet-field */\n.hotel-mobile-sheet-field {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.625rem 0.75rem;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  background: #f5f5f7;\n  box-sizing: border-box;\n  width: 100%;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  font: inherit;\n  color: inherit;\n  text-align: left;\n  margin: 0;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.hotel-mobile-sheet-field:focus-visible {\n  outline: none;\n  border-color: #cf2048;\n  background: #fff;\n}\n\n.hotel-mobile-sheet-field:active {\n  background: #ededf0;\n}\n\n.hotel-mobile-sheet-field-icon {\n  width: 1.125rem;\n  height: 1.125rem;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n  color: #20202a;\n}\n\n.hotel-mobile-sheet-field-label {\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #7e808f;\n  margin-bottom: 0.125rem;\n  display: block;\n}\n\n.hotel-mobile-sheet-field-value {\n  font-family: 'Host Grotesk', sans-serif;\n  font-size: max(16px, 1rem);\n  font-weight: 600;\n  line-height: 1.5;\n  color: #20202a;\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hotel-mobile-sheet-field-value--muted {\n  color: #aeaeb8;\n  font-weight: 500;\n}\n\n/* ===== Phase 1 — Figma 3013:152666 compact container (mobile + tablet <900px) ===== */\n@media (max-width: 899.98px) {\n  .hotel-form-compact-card {\n    background: #e8e9ed;\n    border: none;\n    box-shadow: none;\n    border-radius: var(--yovo-radius-lg, 16px);\n  }\n\n  .hotel-form-compact-card > .MuiCardContent-root {\n    display: flex;\n    flex-direction: column;\n    gap: var(--yovo-space-base, 16px);\n    padding: 16px 12px 24px;\n    box-sizing: border-box;\n  }\n\n  .hotel-form-compact-card > .MuiCardContent-root:last-child {\n    padding-bottom: 24px;\n  }\n\n  .hotel-form-compact-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .hotel-form-compact-inner {\n    background: var(--yovo-base-white, #FBFBFB);\n    border: 1px solid var(--neutrals-grey-400, #DAD9E0);\n    border-radius: 24px;\n    padding: 12px 16px 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .hotel-form-compact-divider {\n    display: none;\n  }\n\n  /* Same row rhythm as the mobile flight card: 14/20 labels, 16/22 values, 10/8 row padding. */\n  .hotel-form-compact-field {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px 4px 8px;\n    border-bottom: 1px solid #e8e9ed;\n  }\n\n  .hotel-form-compact-inner > .hotel-form-compact-field:first-child {\n    padding-top: 8px;\n    padding-bottom: 10px;\n  }\n\n  .hotel-form-compact-inner > .hotel-form-compact-field:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  .hotel-form-compact-field--align-end {\n    align-items: flex-end;\n  }\n\n  .hotel-form-compact-field--align-end .hotel-form-compact-label,\n  .hotel-form-compact-field--align-end .hotel-form-compact-value,\n  .hotel-form-compact-field--align-end .hotel-form-compact-value-trigger {\n    text-align: right;\n  }\n\n  .hotel-form-compact-label,\n  .hotel-form-compact-label--destination {\n    font-family: 'Host Grotesk', sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.15px;\n    color: #20202a;\n  }\n\n  .hotel-form-compact-value {\n    font-family: 'Host Grotesk', sans-serif;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 22px;\n    color: #20202a;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n  }\n\n  .hotel-form-compact-value--placeholder {\n    color: #7e808f;\n    font-weight: 500;\n  }\n\n  .hotel-form-compact-value-trigger {\n    width: 100%;\n    cursor: pointer;\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .hotel-form-compact-error {\n    font-family: var(--yovo-font-primary);\n    font-size: var(--yovo-text-sm);\n    line-height: var(--yovo-leading-sm);\n    color: var(--yovo-error, #D32F2F);\n    margin-top: 2px;\n  }\n\n  .hotel-form-compact-helper {\n    font-family: var(--yovo-font-primary);\n    font-size: 11px;\n    line-height: 1.3;\n    color: var(--yovo-warning, #E65100);\n    margin-top: var(--yovo-space-xs, 4px);\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield {\n    width: 100%;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiOutlinedInput-root {\n    border-radius: 0;\n    min-height: auto;\n    height: auto;\n    background: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiOutlinedInput-root fieldset {\n    border: none;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiOutlinedInput-root.Mui-focused fieldset {\n    border: none;\n    box-shadow: none;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiInputBase-input {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-family: 'Host Grotesk', sans-serif;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 22px;\n    color: #20202a;\n    width: 100%;\n    white-space: nowrap;\n    padding: 0 !important;\n    margin: 0;\n    cursor: pointer;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield .MuiInputBase-input::placeholder {\n    color: #7e808f;\n    font-weight: 500;\n    opacity: 1;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield--nationality .MuiOutlinedInput-root {\n    padding-right: 28px;\n  }\n\n  .hotel-form-compact-inner .hotel-form-compact-textfield--nationality .MuiInputBase-input {\n    caret-color: transparent !important;\n  }\n\n  /* Hotel date row — Figma 3013:152666; stretch columns so swap aligns with label+value block */\n  .hotel-form-compact-date-row {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px 4px 8px;\n    border-bottom: 1px solid #e8e9ed;\n  }\n\n  .hotel-form-compact-date-row > .hotel-form-compact-field {\n    flex: 1 1 0;\n    min-width: 0;\n    padding: 0;\n    border-bottom: none;\n  }\n\n  /*\n   * Hotel swap column — Flight .flight-form-swap-col assumes .flight-search-strip-from-to-row\n   * (stretched airport fields). The hotel date row is label+value stacks, so the column is\n   * centred on the row instead and the rule is sized independently below.\n   */\n  .hotel-form-compact-swap-col {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 40px;\n    width: 40px;\n    min-width: 40px;\n    align-self: center;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  /*\n   * Divider — Figma 3013:160331 is a 68px rule centred on the swap column. The 34px circle\n   * sits in the middle, leaving 17px visible above and below. The track is sized to the\n   * Figma rule rather than the date row, which is only ~46px tall.\n   */\n  .hotel-form-compact-swap-divider-track {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 1px;\n    height: 44px;\n    transform: translate(-50%, -50%);\n    z-index: 0;\n    pointer-events: none;\n  }\n\n  .hotel-form-compact-swap-divider-segment {\n    position: absolute;\n    left: 0;\n    width: 1px;\n    height: 6px;\n    background-color: var(--neutrals-grey-400, #DAD9E0);\n  }\n\n  .hotel-form-compact-swap-divider-segment--top {\n    top: 0;\n  }\n\n  .hotel-form-compact-swap-divider-segment--bottom {\n    bottom: 0;\n  }\n\n  /*\n   * Portalled to <body>, so it clears the homepage card's stacking context and the\n   * absolutely-positioned section content below it (e.g. \"Explore What's Trending\").\n   * Same z-index band as the hotel mobile sheets.\n   */\n  .hotel-form-compact-nationality-menu {\n    z-index: 1310;\n    background-color: var(--yovo-base-white, #FBFBFB);\n  }\n\n  .hotel-form-compact-swap-col .flight-form-swap {\n    border-color: var(--neutrals-grey-800, #434151);\n  }\n\n  /*\n   * Figma 3013:160333 draws the swap at full strength, so the empty-dates state keeps the\n   * same border and arrow contrast; `disabled` still blocks the (no-op) click.\n   */\n  .hotel-form-compact-inner .flight-form-swap:disabled {\n    opacity: 1;\n  }\n\n  .hotel-form-compact-inner .flight-form-swap:disabled:hover,\n  .hotel-form-compact-inner .flight-form-swap:disabled:active {\n    background: var(--neutrals-base-white, #FBFBFB);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
